export default __webpack_public_path__ + "static/media/denver.11d9f819.jpeg";